import defaultTheme from './theme';

export default function cvar(key: keyof typeof defaultTheme) {
  return `var(--ccl-${key}, ${defaultTheme[key]})`;
}
